import React from 'react';
import { cx } from '../../lib/cx';

const TONES = {
  neutral: 'border-line-strong bg-sunken text-muted',
  accent: 'border-accent/30 bg-accent/10 text-accent-fg',
  success: 'border-success/30 bg-success/10 text-success',
  warning: 'border-warning/30 bg-warning/10 text-warning',
  danger: 'border-danger/30 bg-danger/10 text-danger',
  info: 'border-info/30 bg-info/10 text-info',
};

export const Badge = ({ tone = 'neutral', icon: Icon, className, children, ...props }) => (
  <span
    className={cx(
      'inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border px-1.5 py-px text-xs font-medium',
      TONES[tone],
      className,
    )}
    {...props}
  >
    {Icon && <Icon size={12} aria-hidden="true" />}
    {children}
  </span>
);
